import React from 'react';
import {
  TableRow,
  TableCell
} from '@mui/material';
import { DateTime } from 'luxon';
import {
  useNavigate,
  useParams
} from 'react-router-dom';

export type PlanTableRowProps = {
  createdDate: DateTime;
  id: string;
  name: string;
  planSetDisplayName: string;
  updatedDate: DateTime;
  versionCount: string;
};

export const FC = (props: PlanTableRowProps) => {
  const params = useParams();
  const navigate = useNavigate();

  return (
    <TableRow
      content='list'
      onClick={(e) => {
        e.stopPropagation();
        if (params.planSetId) {
          navigate(`../../plans/${props.id}`);
        } else {
          navigate(`${props.id}`);
        }
      }}
    >
      <TableCell
        variant='firstRounded'
      >
        {props.name}
      </TableCell>
      <TableCell
        variant='body'
      >
        {props.createdDate.toFormat('DDDD')}
      </TableCell>
      <TableCell
        variant='body'
      >
        {props.planSetDisplayName}
      </TableCell>
      <TableCell
        variant='body'
      >
        {props.updatedDate.toFormat('DDDD')}
      </TableCell>
      <TableCell
        variant='lastRounded'
      >
        {props.versionCount}
      </TableCell>
    </TableRow>

  );
};
